import React, { useEffect, useState, useRef, Component } from 'react';
import { Shield, Home, PlusCircle, History, User, MapPin, Camera, AlertTriangle, ChevronLeft, ChevronRight, Send, CheckCircle, Upload, FileImage, Save, Map as MapIcon, Activity, Target, Clock, Fingerprint, Wifi, Battery, Signal, Bell, Filter, X, RefreshCw, Search, FileText, Paperclip, Trash2, LogOut, Smartphone, Check } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
import { Badge } from '../components/Badge';
import { toast } from 'sonner';
import { UrgencyBadge } from '../components/UrgencyBadge';
import { StatusBadge } from '../components/StatusBadge';
import { KPICard } from '../components/KPICard';
import { useScreenInit } from '../useScreenInit';
import { useStore } from '../data/store';
import { useUkstrStore } from '../data/ukstrStore';
type ScreenType = 'login' | 'dashboard' | 'create-report' | 'report-detail' | 'history' | 'kpi' | 'panic' | 'profile' | 'notifications' | 'tasks';
export default function MobileApp() {
  useScreenInit('scr_jyu5k6');
  const [activeScreen, setActiveScreen] = useState<ScreenType>('login');
  const [selectedReportId, setSelectedReportId] = useState<string | null>(null);
  const isLogin = activeScreen === 'login';
  const isPanic = activeScreen === 'panic';
  const hideNav = isLogin || isPanic || activeScreen === 'create-report';
  return <div className="fixed inset-0 bg-background flex flex-col overflow-hidden font-sans text-foreground" data-id="element-2014">
      {/* Header */}
      {!isLogin && !isPanic && <div className="bg-sidebar/95 backdrop-blur-md pb-3 pt-4 px-4 border-b border-border/50 z-10 flex justify-between items-center shrink-0" data-id="element-2015">
          <div className="flex items-center gap-2 mt-2" data-id="element-2016">
            <img src="https://cdn.magicpatterns.com/uploads/hos8i69ZV8fMbtkJgKVvED/Logo_BIN_NEW.png" alt="Logo Badan Intelijen Negara" className="w-6 h-6 object-contain" data-id="element-2017" />
            <span className="text-sm font-bold tracking-widest text-primary" data-id="element-2018">
              DENS CAKRA
            </span>
          </div>
          <div className="flex items-center gap-4 mt-2" data-id="element-2019">
            <button onClick={() => setActiveScreen('notifications')} className="relative p-2" data-id="element-2020">
              <Bell className="w-5 h-5 text-muted-foreground hover:text-foreground transition-colors" data-id="element-2021" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-destructive" data-id="element-2022"></span>
            </button>
          </div>
        </div>}

      {/* Content Area */}
      <div className="flex-1 overflow-y-auto custom-scrollbar relative bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] bg-repeat" data-id="element-2023">
        <div className="p-4 min-h-full pb-24" data-id="element-2024">
          {activeScreen === 'login' && <LoginScreen onNavigate={setActiveScreen} data-id="element-2025" />}
          {activeScreen === 'dashboard' && <DashboardScreen onNavigate={setActiveScreen} data-id="element-2026" />}
          {activeScreen === 'create-report' && <CreateReportWizard onNavigate={setActiveScreen} data-id="element-2027" />}
          {activeScreen === 'report-detail' && <ReportDetailScreen onNavigate={setActiveScreen} selectedReportId={selectedReportId} data-id="element-2028" />}
          {activeScreen === 'history' && <HistoryScreen onNavigate={setActiveScreen} onSelectReport={setSelectedReportId} data-id="element-2029" />}
          {activeScreen === 'kpi' && <KPIScreen onNavigate={setActiveScreen} data-id="element-2030" />}
          {activeScreen === 'panic' && <PanicScreen onNavigate={setActiveScreen} data-id="element-2031" />}
          {activeScreen === 'profile' && <ProfileScreen onNavigate={setActiveScreen} data-id="element-2032" />}
          {activeScreen === 'notifications' && <NotificationsScreen onNavigate={setActiveScreen} data-id="element-2033" />}
          {activeScreen === 'tasks' && <TasksScreen onNavigate={setActiveScreen} data-id="element-2034" />}
        </div>
      </div>

      {/* Bottom Navigation */}
      {!hideNav && <div className="absolute bottom-0 inset-x-0 bg-sidebar/95 backdrop-blur-md border-t border-border/50 flex justify-around items-center z-20 pb-6 pt-2 px-2 shadow-[0_-10px_40px_rgba(0,0,0,0.5)]" data-id="element-2035">
          <NavButton icon={Home} label="Beranda" active={activeScreen === 'dashboard'} onClick={() => setActiveScreen('dashboard')} data-id="element-2036" />
          <NavButton icon={FileText} label="Tugas" active={activeScreen === 'tasks'} onClick={() => setActiveScreen('tasks')} data-id="element-2037" />
          <NavButton icon={History} label="Riwayat" active={activeScreen === 'history' || activeScreen === 'report-detail'} onClick={() => setActiveScreen('history')} data-id="element-2038" />

          <div className="relative -top-6" data-id="element-2039">
            <button onClick={() => setActiveScreen('create-report')} className="w-14 h-14 rounded-full bg-primary border-4 border-background flex items-center justify-center shadow-[0_0_20px_rgba(var(--primary),0.4)] active:scale-95 transition-transform" data-id="element-2040">
              <PlusCircle className="w-6 h-6 text-primary-foreground" data-id="element-2041" />
            </button>
          </div>

          <NavButton icon={Target} label="KPI" active={activeScreen === 'kpi'} onClick={() => setActiveScreen('kpi')} data-id="element-2042" />
          <NavButton icon={User} label="Profil" active={activeScreen === 'profile'} onClick={() => setActiveScreen('profile')} data-id="element-2043" />
        </div>}
    </div>;
}
function NavButton({
  icon: Icon,
  label,
  active,
  onClick
}: {
  icon: any;
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return <button onClick={onClick} className={`flex flex-col items-center gap-1 p-2 min-w-[64px] transition-colors ${active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`} data-id="element-2044">
      <Icon className={`w-6 h-6 ${active ? 'fill-primary/20' : ''}`} data-id="element-2045" />
      <span className="text-[10px] font-medium" data-id="element-2046">{label}</span>
    </button>;
}
// --- Screen Components ---
function LoginScreen({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  const [showEnterprise, setShowEnterprise] = useState(false);
  return <div className="flex flex-col items-center justify-center min-h-[80vh] space-y-8 animate-in fade-in px-4" data-id="element-2047">
      <div className="flex flex-col items-center text-center" data-id="element-2048">
        <div className="w-28 h-28 flex items-center justify-center mb-6" data-id="element-2049">
          <img src="https://cdn.magicpatterns.com/uploads/hos8i69ZV8fMbtkJgKVvED/Logo_BIN_NEW.png" alt="Logo Badan Intelijen Negara" className="w-full h-full object-contain drop-shadow-[0_0_30px_rgba(var(--primary),0.3)]" data-id="element-2050" />
        </div>
        <h1 className="text-3xl font-bold tracking-widest text-primary mb-2" data-id="element-2051">
          DENS CAKRA
        </h1>
        <p className="text-xs font-mono text-muted-foreground tracking-widest uppercase mb-1" data-id="element-2052">
          Dashboard Evaluasi Nasional
        </p>
        <p className="text-xs font-mono text-muted-foreground tracking-widest uppercase" data-id="element-2053">
          dan Situational Awareness
        </p>
      </div>

      <div className="w-full max-w-sm space-y-6 bg-black/40 p-6 rounded-2xl border border-border/50 backdrop-blur-sm" data-id="element-2054">
        {!showEnterprise ? <>
            <div className="text-center space-y-2 mb-6" data-id="element-2055">
              <div className="text-xs text-muted-foreground uppercase tracking-wider" data-id="element-2056">
                Role Demo
              </div>
              <div className="text-lg font-bold text-foreground" data-id="element-2057">
                Personel Lapangan
              </div>
            </div>
            <Button className="w-full h-14 text-base font-bold bg-primary hover:bg-primary/90 text-primary-foreground shadow-[0_0_20px_rgba(var(--primary),0.3)]" onClick={() => onNavigate('dashboard')} data-id="element-2058">
              MASUK DEMO
            </Button>
            <Button variant="ghost" className="w-full text-xs text-muted-foreground" onClick={() => setShowEnterprise(true)} data-id="element-2059">
              Login Enterprise
            </Button>
          </> : <div className="space-y-4 animate-in slide-in-from-right-4" data-id="element-2060">
            <div className="space-y-2" data-id="element-2061">
              <label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-2062">
                ID Pengguna
              </label>
              <input className="w-full bg-black/60 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 transition-colors" placeholder="OP-772" defaultValue="OP-772" data-id="element-2063" />
            </div>
            <div className="space-y-2" data-id="element-2064">
              <label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-2065">
                Kata Sandi
              </label>
              <input className="w-full bg-black/60 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 transition-colors" type="password" placeholder="••••••••" defaultValue="password" data-id="element-2066" />
            </div>
            <div className="space-y-2" data-id="element-2067">
              <label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-2068">
                MFA Token
              </label>
              <input className="w-full bg-black/60 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 transition-colors tracking-widest" placeholder="000000" defaultValue="849201" data-id="element-2069" />
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground bg-primary/10 p-3 rounded-lg border border-primary/20" data-id="element-2070">
              <Smartphone className="w-4 h-4 text-primary" data-id="element-2071" />
              <span data-id="element-2072">Device Binding: Terverifikasi</span>
            </div>
            <div className="pt-2 space-y-3" data-id="element-2073">
              <Button className="w-full h-12 bg-primary hover:bg-primary/90 text-primary-foreground" onClick={() => onNavigate('dashboard')} data-id="element-2074">
                OTENTIKASI
              </Button>
              <Button variant="ghost" className="w-full text-xs" onClick={() => setShowEnterprise(false)} data-id="element-2075">
                Kembali ke Demo
              </Button>
            </div>
          </div>}
      </div>
    </div>;
}
function DashboardScreen({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  const reports = useStore(s => s.reports);
  const myReports = reports.filter(r => r.sender === 'OP-772' || r.sender === 'Personel Lapangan');
  const drafts = myReports.filter(r => r.stage === 'Draft');
  const sent = myReports.filter(r => r.stage !== 'Draft');
  const accepted = myReports.filter(r => r.status === 'Diterima Nasional');
  const personalKpi = useStore(s => s.personalKpi);
  return <div className="space-y-6 animate-in fade-in" data-id="element-2076">
      <div className="flex justify-between items-start" data-id="element-2077">
        <div data-id="element-2078">
          <h2 className="text-xl font-bold text-foreground" data-id="element-2079">
            Selamat bertugas,
          </h2>
          <p className="text-lg text-primary font-medium" data-id="element-2080">Operator Lapangan</p>
        </div>
        <div className="flex items-center gap-2 bg-black/40 px-3 py-1.5 rounded-full border border-border/50" data-id="element-2081">
          <div className="w-2 h-2 rounded-full bg-[var(--status-active)] animate-pulse" data-id="element-2082"></div>
          <span className="text-xs font-mono text-[var(--status-active)]" data-id="element-2083">
            Aktif
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3" data-id="element-2084">
        <Card className="bg-black/40 border-border/50" data-id="element-2085">
          <CardContent className="p-4 flex flex-col items-center justify-center text-center" data-id="element-2086">
            <div className="text-3xl font-mono text-foreground mb-1" data-id="element-2087">
              {myReports.length}
            </div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2088">
              Laporan Bulan Ini
            </div>
          </CardContent>
        </Card>
        <Card className="bg-black/40 border-border/50" onClick={() => onNavigate('history')} data-id="element-2089">
          <CardContent className="p-4 flex flex-col items-center justify-center text-center" data-id="element-2090">
            <div className="text-3xl font-mono text-[var(--status-standby)] mb-1" data-id="element-2091">
              {drafts.length}
            </div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2092">
              Draft Offline
            </div>
          </CardContent>
        </Card>
        <Card className="bg-black/40 border-border/50" data-id="element-2093">
          <CardContent className="p-4 flex flex-col items-center justify-center text-center" data-id="element-2094">
            <div className="text-3xl font-mono text-primary mb-1" data-id="element-2095">
              {sent.length}
            </div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2096">
              Laporan Dikirim
            </div>
          </CardContent>
        </Card>
        <Card className="bg-black/40 border-border/50" data-id="element-2097">
          <CardContent className="p-4 flex flex-col items-center justify-center text-center" data-id="element-2098">
            <div className="text-3xl font-mono text-[var(--status-active)] mb-1" data-id="element-2099">
              {accepted.length}
            </div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2100">
              Diterima Nasional
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="bg-primary/10 border border-primary/30 rounded-xl p-4 relative overflow-hidden" onClick={() => onNavigate('kpi')} data-id="element-2101">
        <div className="absolute -right-4 -top-4 opacity-10" data-id="element-2102">
          <Target className="w-32 h-32" data-id="element-2103" />
        </div>
        <div className="relative z-10 flex justify-between items-center" data-id="element-2104">
          <div data-id="element-2105">
            <h3 className="text-sm font-bold text-primary mb-1" data-id="element-2106">KPI Pribadi</h3>
            <div className="text-2xl font-mono font-bold" data-id="element-2107">
              {personalKpi.score}{' '}
              <span className="text-sm text-muted-foreground" data-id="element-2108">/ 100</span>
            </div>
          </div>
          <div className="text-right" data-id="element-2109">
            <div className="text-xs text-muted-foreground mb-1" data-id="element-2110">
              Status Sinkronisasi
            </div>
            <div className="flex items-center gap-1 text-xs text-[var(--status-active)] font-mono" data-id="element-2111">
              <CheckCircle className="w-3 h-3" data-id="element-2112" /> Tersinkron
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-3 pt-2" data-id="element-2113">
        <Button className="w-full h-14 text-base font-bold bg-primary hover:bg-primary/90 text-primary-foreground shadow-[0_0_15px_rgba(var(--primary),0.3)]" onClick={() => onNavigate('create-report')} data-id="element-2114">
          <PlusCircle className="w-5 h-5 mr-2" data-id="element-2115" /> BUAT LAPORAN
        </Button>
        <Button variant="outline" className="w-full h-14 text-base font-bold border-destructive text-destructive hover:bg-destructive hover:text-destructive-foreground shadow-[0_0_15px_rgba(var(--destructive),0.2)]" onClick={() => onNavigate('panic')} data-id="element-2116">
          <AlertTriangle className="w-5 h-5 mr-2" data-id="element-2117" /> PANIC BUTTON
        </Button>
      </div>
    </div>;
}
function CreateReportWizard({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  const [step, setStep] = useState(1);
  const createReport = useStore(s => s.createReport);
  const submitReport = useStore(s => s.submitReport);
  // Form State
  const [type, setType] = useState('Laporan Informasi');
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('Keamanan');
  const [urgency, setUrgency] = useState('Sedang');
  const [summary, setSummary] = useState('');
  const [desc, setDesc] = useState('');
  const [chronology, setChronology] = useState('');
  const [actors, setActors] = useState('');
  const [impact, setImpact] = useState('');
  const [recommendation, setRecommendation] = useState('');
  const [locationMode, setLocationMode] = useState('gps');
  const [attachments, setAttachments] = useState<{
    name: string;
    kind: 'foto' | 'dokumen';
  }[]>([]);
  const [createdId, setCreatedId] = useState('');
  const [isOffline, setIsOffline] = useState(false);
  const handleNext = () => setStep(s => s + 1);
  const handlePrev = () => setStep(s => s - 1);
  const handleSaveDraft = () => {
    if (!title) {
      toast.error('Judul laporan wajib diisi');
      return;
    }
    createReport({
      title,
      type,
      category,
      urgency,
      region: 'DKI Jakarta',
      sender: 'OP-772',
      ringkasan: summary,
      description: desc,
      kronologi: chronology,
      pihakTerkait: actors,
      potensiDampak: impact,
      rekomendasiAwal: recommendation,
      offline: true,
      attachments
    });
    toast.success('Draft berhasil disimpan offline');
    onNavigate('history');
  };
  const handleSubmit = () => {
    if (!title) {
      toast.error('Judul laporan wajib diisi');
      return;
    }
    const report = createReport({
      title,
      type,
      category,
      urgency,
      region: 'DKI Jakarta',
      sender: 'OP-772',
      ringkasan: summary,
      description: desc,
      kronologi: chronology,
      pihakTerkait: actors,
      potensiDampak: impact,
      rekomendasiAwal: recommendation,
      offline: isOffline,
      attachments
    });
    if (!isOffline) {
      submitReport(report.id);
    }
    setCreatedId(report.id);
    setStep(6);
  };
  const addAttachment = (kind: 'foto' | 'dokumen') => {
    const name = kind === 'foto' ? `foto_lokasi_00${attachments.length + 1}.jpg` : `dokumen_pendukung_00${attachments.length + 1}.pdf`;
    setAttachments([...attachments, {
      name,
      kind
    }]);
    toast.success(`${kind === 'foto' ? 'Foto' : 'Dokumen'} berhasil ditambahkan`);
  };
  const removeAttachment = (index: number) => {
    setAttachments(attachments.filter((_, i) => i !== index));
  };
  if (step === 6) {
    return <div className="flex flex-col items-center justify-center min-h-[70vh] space-y-6 animate-in zoom-in-95" data-id="element-2118">
        <div className="w-24 h-24 rounded-full bg-[var(--status-active)]/20 flex items-center justify-center border-4 border-[var(--status-active)]/50" data-id="element-2119">
          <CheckCircle className="w-12 h-12 text-[var(--status-active)]" data-id="element-2120" />
        </div>
        <div className="text-center space-y-2" data-id="element-2121">
          <h2 className="text-2xl font-bold text-foreground" data-id="element-2122">
            Laporan Berhasil {isOffline ? 'Disimpan' : 'Dikirim'}
          </h2>
          <p className="text-sm text-muted-foreground" data-id="element-2123">Nomor Laporan:</p>
          <p className="text-xl font-mono font-bold text-primary" data-id="element-2124">
            {createdId}
          </p>
          <Badge variant="outline" className="mt-2 text-sm px-4 py-1" data-id="element-2125">
            {isOffline ? 'DRAFT OFFLINE' : 'DIKIRIM'}
          </Badge>
        </div>

        <div className="w-full bg-black/40 border border-border/50 rounded-xl p-4 mt-4" data-id="element-2126">
          <h4 className="text-xs font-bold uppercase text-muted-foreground mb-3" data-id="element-2127">
            Timeline Laporan
          </h4>
          <div className="space-y-3" data-id="element-2128">
            <div className="flex items-center gap-3 text-sm text-[var(--status-active)]" data-id="element-2129">
              <CheckCircle className="w-4 h-4" data-id="element-2130" /> <span data-id="element-2131">Draft</span>
            </div>
            <div className={`flex items-center gap-3 text-sm ${!isOffline ? 'text-[var(--status-active)]' : 'text-muted-foreground'}`} data-id="element-2132">
              {!isOffline ? <CheckCircle className="w-4 h-4" data-id="element-2133" /> : <div className="w-4 h-4 rounded-full border-2 border-muted-foreground" data-id="element-2134" />}
              <span data-id="element-2135">Dikirim</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-muted-foreground" data-id="element-2136">
              <div className="w-4 h-4 rounded-full border-2 border-muted-foreground" data-id="element-2137" />{' '}
              <span data-id="element-2138">Review BINDA</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-muted-foreground" data-id="element-2139">
              <div className="w-4 h-4 rounded-full border-2 border-muted-foreground" data-id="element-2140" />{' '}
              <span data-id="element-2141">Diverifikasi BINDA</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-muted-foreground" data-id="element-2142">
              <div className="w-4 h-4 rounded-full border-2 border-muted-foreground" data-id="element-2143" />{' '}
              <span data-id="element-2144">Diterima Nasional</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-muted-foreground" data-id="element-2145">
              <div className="w-4 h-4 rounded-full border-2 border-muted-foreground" data-id="element-2146" />{' '}
              <span data-id="element-2147">Masuk KPI</span>
            </div>
          </div>
        </div>

        <div className="w-full space-y-3 pt-4" data-id="element-2148">
          <Button className="w-full h-12 bg-primary" onClick={() => onNavigate('history')} data-id="element-2149">
            Lihat Status Laporan
          </Button>
          <Button variant="outline" className="w-full h-12" onClick={() => onNavigate('dashboard')} data-id="element-2150">
            Kembali ke Beranda
          </Button>
        </div>
      </div>;
  }
  return <div className="space-y-6 pb-20 animate-in slide-in-from-right-4" data-id="element-2151">
      <div className="flex items-center gap-3 mb-6" data-id="element-2152">
        <Button variant="ghost" size="icon" onClick={step === 1 ? () => onNavigate('dashboard') : handlePrev} data-id="element-2153">
          <ChevronLeft className="w-6 h-6" data-id="element-2154" />
        </Button>
        <div className="flex-1" data-id="element-2155">
          <h2 className="text-lg font-bold" data-id="element-2156">Buat Laporan</h2>
          <div className="flex gap-1 mt-2" data-id="element-2157">
            {[1, 2, 3, 4, 5].map(i => <div key={i} className={`h-1.5 flex-1 rounded-full ${i <= step ? 'bg-primary' : 'bg-border'}`} data-id="element-2158" />)}
          </div>
        </div>
      </div>

      {step === 1 && <div className="space-y-4" data-id="element-2159">
          <h3 className="text-sm font-bold uppercase text-muted-foreground mb-4" data-id="element-2160">
            Langkah 1: Pilih Jenis Laporan
          </h3>
          <div className="grid gap-3" data-id="element-2161">
            {['Laporan Informasi', 'Laporan Kejadian', 'Laporan Cepat', 'Laporan Harian', 'Laporan Khusus', 'Laporan Darurat'].map(t => <button key={t} onClick={() => setType(t)} className={`p-4 rounded-xl border text-left transition-all ${type === t ? 'bg-primary/20 border-primary shadow-[0_0_15px_rgba(var(--primary),0.2)]' : 'bg-black/40 border-border/50'}`} data-id="element-2162">
                <div className="font-bold text-base" data-id="element-2163">{t}</div>
              </button>)}
          </div>
        </div>}

      {step === 2 && <div className="space-y-5" data-id="element-2164">
          <h3 className="text-sm font-bold uppercase text-muted-foreground mb-2" data-id="element-2165">
            Langkah 2: Isi Bahan Keterangan
          </h3>

          <div className="space-y-2" data-id="element-2166">
            <label className="text-xs font-bold uppercase" data-id="element-2167">
              Judul Informasi <span className="text-destructive" data-id="element-2168">*</span>
            </label>
            <input className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50" placeholder="Masukkan judul laporan..." value={title} onChange={e => setTitle(e.target.value)} data-id="element-2169" />
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-2170">
            <div className="space-y-2" data-id="element-2171">
              <label className="text-xs font-bold uppercase" data-id="element-2172">Kategori</label>
              <select className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 appearance-none" value={category} onChange={e => setCategory(e.target.value)} data-id="element-2173">
                {['Politik', 'Sosial', 'Ekonomi', 'Keamanan', 'Siber', 'Konflik Sosial', 'Infrastruktur Strategis', 'Objek Vital Nasional', 'Bencana', 'Lintas Negara'].map(c => <option key={c} value={c} data-id="element-2174">
                    {c}
                  </option>)}
              </select>
            </div>
            <div className="space-y-2" data-id="element-2175">
              <label className="text-xs font-bold uppercase" data-id="element-2176">Urgensi</label>
              <select className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 appearance-none" value={urgency} onChange={e => setUrgency(e.target.value)} data-id="element-2177">
                {['Rendah', 'Sedang', 'Tinggi', 'Kritis'].map(u => <option key={u} value={u} data-id="element-2178">
                    {u}
                  </option>)}
              </select>
            </div>
          </div>

          <div className="space-y-2" data-id="element-2179">
            <label className="text-xs font-bold uppercase" data-id="element-2180">Ringkasan</label>
            <textarea className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 min-h-[80px]" placeholder="Ringkasan singkat..." value={summary} onChange={e => setSummary(e.target.value)} data-id="element-2181" />
          </div>

          <div className="space-y-2" data-id="element-2182">
            <label className="text-xs font-bold uppercase" data-id="element-2183">
              Uraian Lengkap
            </label>
            <textarea className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 min-h-[120px]" placeholder="Uraian detail kejadian/informasi..." value={desc} onChange={e => setDesc(e.target.value)} data-id="element-2184" />
          </div>

          <div className="space-y-2" data-id="element-2185">
            <label className="text-xs font-bold uppercase" data-id="element-2186">
              Kronologi Singkat
            </label>
            <textarea className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 min-h-[80px]" value={chronology} onChange={e => setChronology(e.target.value)} data-id="element-2187" />
          </div>

          <div className="space-y-2" data-id="element-2188">
            <label className="text-xs font-bold uppercase" data-id="element-2189">Pihak Terkait</label>
            <input className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50" value={actors} onChange={e => setActors(e.target.value)} data-id="element-2190" />
          </div>

          <div className="space-y-2" data-id="element-2191">
            <label className="text-xs font-bold uppercase" data-id="element-2192">
              Potensi Dampak
            </label>
            <input className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50" value={impact} onChange={e => setImpact(e.target.value)} data-id="element-2193" />
          </div>

          <div className="space-y-2" data-id="element-2194">
            <label className="text-xs font-bold uppercase" data-id="element-2195">
              Rekomendasi Awal
            </label>
            <textarea className="w-full bg-black/40 border border-border/50 rounded-lg p-3 text-sm focus:outline-none focus:border-primary/50 min-h-[80px]" value={recommendation} onChange={e => setRecommendation(e.target.value)} data-id="element-2196" />
          </div>
        </div>}

      {step === 3 && <div className="space-y-5" data-id="element-2197">
          <h3 className="text-sm font-bold uppercase text-muted-foreground mb-2" data-id="element-2198">
            Langkah 3: Lokasi dan Geotag
          </h3>

          <div className="flex bg-black/40 border border-border/50 rounded-lg p-1 mb-4" data-id="element-2199">
            <button onClick={() => setLocationMode('gps')} className={`flex-1 py-2 text-sm font-bold rounded-md transition-colors ${locationMode === 'gps' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground'}`} data-id="element-2200">
              GPS Saat Ini
            </button>
            <button onClick={() => setLocationMode('manual')} className={`flex-1 py-2 text-sm font-bold rounded-md transition-colors ${locationMode === 'manual' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground'}`} data-id="element-2201">
              Pilih Manual
            </button>
          </div>

          <div className="w-full h-48 bg-secondary/50 rounded-xl border border-border/50 relative overflow-hidden flex items-center justify-center" data-id="element-2202">
            <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/hos8i69ZV8fMbtkJgKVvED/map-bg.png')] bg-cover bg-center opacity-50 mix-blend-overlay" data-id="element-2203"></div>
            <div className="relative z-10 flex flex-col items-center" data-id="element-2204">
              <MapPin className="w-10 h-10 text-primary animate-bounce" data-id="element-2205" />
              <div className="w-4 h-1 bg-black/50 rounded-full blur-sm mt-1" data-id="element-2206"></div>
            </div>
          </div>

          <div className="bg-black/40 border border-border/50 rounded-xl p-4 space-y-3" data-id="element-2207">
            <div className="flex justify-between items-center border-b border-border/50 pb-2" data-id="element-2208">
              <span className="text-xs text-muted-foreground" data-id="element-2209">Latitude</span>
              <span className="text-sm font-mono" data-id="element-2210">-6.2088</span>
            </div>
            <div className="flex justify-between items-center border-b border-border/50 pb-2" data-id="element-2211">
              <span className="text-xs text-muted-foreground" data-id="element-2212">Longitude</span>
              <span className="text-sm font-mono" data-id="element-2213">106.8456</span>
            </div>
            <div className="flex justify-between items-center border-b border-border/50 pb-2" data-id="element-2214">
              <span className="text-xs text-muted-foreground" data-id="element-2215">Akurasi</span>
              <span className="text-sm font-mono text-[var(--status-active)]" data-id="element-2216">
                ± 4 meter
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-2217">
              <span className="text-xs text-muted-foreground" data-id="element-2218">Waktu</span>
              <span className="text-sm font-mono" data-id="element-2219">
                {new Date().toLocaleTimeString()}
              </span>
            </div>
          </div>
        </div>}

      {step === 4 && <div className="space-y-5" data-id="element-2220">
          <h3 className="text-sm font-bold uppercase text-muted-foreground mb-2" data-id="element-2221">
            Langkah 4: Upload Lampiran
          </h3>

          <div className="grid grid-cols-2 gap-3" data-id="element-2222">
            <button onClick={() => addAttachment('foto')} className="bg-black/40 border border-dashed border-border/50 hover:border-primary/50 rounded-xl p-6 flex flex-col items-center justify-center gap-2 transition-colors" data-id="element-2223">
              <Camera className="w-8 h-8 text-muted-foreground" data-id="element-2224" />
              <span className="text-xs font-bold" data-id="element-2225">Ambil Foto</span>
            </button>
            <button onClick={() => addAttachment('dokumen')} className="bg-black/40 border border-dashed border-border/50 hover:border-primary/50 rounded-xl p-6 flex flex-col items-center justify-center gap-2 transition-colors" data-id="element-2226">
              <Upload className="w-8 h-8 text-muted-foreground" data-id="element-2227" />
              <span className="text-xs font-bold" data-id="element-2228">Upload File</span>
            </button>
          </div>

          {attachments.length > 0 && <div className="space-y-2 mt-6" data-id="element-2229">
              <h4 className="text-xs font-bold uppercase text-muted-foreground mb-2" data-id="element-2230">
                File Terlampir
              </h4>
              {attachments.map((att, i) => <div key={i} className="flex items-center justify-between bg-black/40 border border-border/50 p-3 rounded-lg" data-id="element-2231">
                  <div className="flex items-center gap-3" data-id="element-2232">
                    {att.kind === 'foto' ? <FileImage className="w-5 h-5 text-primary" data-id="element-2233" /> : <FileText className="w-5 h-5 text-primary" data-id="element-2234" />}
                    <span className="text-sm font-mono truncate max-w-[200px]" data-id="element-2235">
                      {att.name}
                    </span>
                  </div>
                  <button onClick={() => removeAttachment(i)} className="p-2 text-destructive hover:bg-destructive/10 rounded-md" data-id="element-2236">
                    <Trash2 className="w-4 h-4" data-id="element-2237" />
                  </button>
                </div>)}
            </div>}
        </div>}

      {step === 5 && <div className="space-y-5" data-id="element-2238">
          <h3 className="text-sm font-bold uppercase text-muted-foreground mb-2" data-id="element-2239">
            Langkah 5: Pratinjau Laporan
          </h3>

          <div className="bg-black/40 border border-border/50 rounded-xl p-4 space-y-4" data-id="element-2240">
            <div data-id="element-2241">
              <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2242">
                Jenis Laporan
              </div>
              <div className="font-bold" data-id="element-2243">{type}</div>
            </div>
            <div data-id="element-2244">
              <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2245">
                Judul
              </div>
              <div className="font-bold text-primary" data-id="element-2246">{title || '-'}</div>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-2247">
              <div data-id="element-2248">
                <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2249">
                  Kategori
                </div>
                <div data-id="element-2250">{category}</div>
              </div>
              <div data-id="element-2251">
                <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2252">
                  Urgensi
                </div>
                <UrgencyBadge urgency={urgency as any} className="text-xs" data-id="element-2253" />
              </div>
            </div>
            <div data-id="element-2254">
              <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2255">
                Lokasi
              </div>
              <div className="flex items-center gap-1 text-sm font-mono" data-id="element-2256">
                <MapPin className="w-3 h-3" data-id="element-2257" /> -6.2088, 106.8456
              </div>
            </div>
            <div data-id="element-2258">
              <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2259">
                Uraian
              </div>
              <div className="text-sm p-3 bg-black/30 rounded border border-border/30" data-id="element-2260">
                {desc || summary || '-'}
              </div>
            </div>
            <div data-id="element-2261">
              <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2262">
                Lampiran
              </div>
              <div className="text-sm" data-id="element-2263">{attachments.length} file terlampir</div>
            </div>
          </div>

          <div className="flex items-center gap-2 mt-4" data-id="element-2264">
            <input type="checkbox" id="offline" checked={isOffline} onChange={e => setIsOffline(e.target.checked)} className="w-4 h-4 accent-primary" data-id="element-2265" />
            <label htmlFor="offline" className="text-sm" data-id="element-2266">
              Simpan sebagai Draft Offline (Tidak langsung dikirim)
            </label>
          </div>
        </div>}

      {/* Sticky Bottom Actions */}
      <div className="fixed bottom-0 inset-x-0 p-4 bg-sidebar/95 backdrop-blur-md border-t border-border/50 flex gap-3 z-30 pb-6" data-id="element-2267">
        {step < 5 ? <>
            <Button variant="outline" className="flex-1 h-12" onClick={handleSaveDraft} data-id="element-2268">
              Simpan Draft
            </Button>
            <Button className="flex-1 h-12 bg-primary" onClick={handleNext} data-id="element-2269">
              Lanjutkan
            </Button>
          </> : <>
            <Button variant="outline" className="flex-1 h-12" onClick={() => setStep(2)} data-id="element-2270">
              Edit
            </Button>
            <Button className="flex-1 h-12 bg-primary" onClick={handleSubmit} data-id="element-2271">
              {isOffline ? 'Simpan Offline' : 'Kirim Laporan'}
            </Button>
          </>}
      </div>
    </div>;
}
function HistoryScreen({
  onNavigate,
  onSelectReport
}: {
  onNavigate: (s: ScreenType) => void;
  onSelectReport: (id: string) => void;
}) {
  const reports = useStore(s => s.reports).filter(r => r.sender === 'OP-772' || r.sender === 'Personel Lapangan');
  const syncOfflineReport = useStore(s => s.syncOfflineReport);
  const [tab, setTab] = useState('Semua');
  const filtered = reports.filter(r => {
    if (tab === 'Draft' && r.stage !== 'Draft') return false;
    if (tab === 'Dikirim' && r.stage === 'Draft') return false;
    return true;
  });
  const handleSync = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    toast.promise(new Promise(resolve => setTimeout(resolve, 1500)), {
      loading: 'Menyinkronkan laporan...',
      success: () => {
        syncOfflineReport(id);
        return 'Laporan berhasil disinkronkan dan dikirim';
      },
      error: 'Gagal menyinkronkan'
    });
  };
  return <div className="space-y-4 animate-in fade-in flex flex-col h-full" data-id="element-2272">
      <h2 className="text-xl font-bold" data-id="element-2273">Riwayat Laporan</h2>

      <div className="flex bg-black/40 border border-border/50 rounded-lg p-1" data-id="element-2274">
        {['Semua', 'Dikirim', 'Draft'].map(t => <button key={t} onClick={() => setTab(t)} className={`flex-1 py-2 text-sm font-bold rounded-md transition-colors ${tab === t ? 'bg-primary text-primary-foreground' : 'text-muted-foreground'}`} data-id="element-2275">
            {t}
          </button>)}
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2 custom-scrollbar -mx-4 px-4" data-id="element-2276">
        {['Semua Waktu', 'Hari Ini', 'Minggu Ini', 'Bulan Ini'].map(f => <button key={f} className="whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-mono bg-black/40 border border-border/50 text-muted-foreground" data-id="element-2277">
            {f}
          </button>)}
      </div>

      <div className="space-y-3 pb-20" data-id="element-2278">
        {filtered.length === 0 ? <div className="text-center p-8 text-muted-foreground" data-id="element-2279">
            Tidak ada laporan.
          </div> : filtered.map(r => <div key={r.id} onClick={() => {
        onSelectReport(r.id);
        onNavigate('report-detail');
      }} className="bg-black/40 border border-border/50 rounded-xl p-4 active:bg-primary/10 transition-colors" data-id="element-2280">
              <div className="flex justify-between items-start mb-2" data-id="element-2281">
                <div className="text-xs font-mono text-muted-foreground" data-id="element-2282">
                  {r.id}
                </div>
                {r.stage === 'Draft' ? <Badge variant="outline" className="text-[10px] border-[var(--status-standby)] text-[var(--status-standby)]" data-id="element-2283">
                    OFFLINE DRAFT
                  </Badge> : <StatusBadge status={r.status} className="text-[10px]" data-id="element-2284" />}
              </div>
              <h4 className="font-bold text-sm mb-1" data-id="element-2285">{r.title}</h4>
              <div className="flex justify-between items-end mt-3" data-id="element-2286">
                <div className="flex items-center gap-2 text-xs text-muted-foreground font-mono" data-id="element-2287">
                  <Clock className="w-3 h-3" data-id="element-2288" /> {r.time.split(' ')[1]}
                </div>
                <UrgencyBadge urgency={r.urgency as any} className="text-[10px]" data-id="element-2289" />
              </div>

              {r.stage === 'Draft' && <Button className="w-full mt-4 h-10 bg-[var(--status-standby)]/20 text-[var(--status-standby)] hover:bg-[var(--status-standby)]/30 border border-[var(--status-standby)]/50" onClick={e => handleSync(r.id, e)} data-id="element-2290">
                  <RefreshCw className="w-4 h-4 mr-2" data-id="element-2291" /> Sinkronkan Sekarang
                </Button>}
            </div>)}
      </div>
    </div>;
}
function ReportDetailScreen({
  onNavigate,
  selectedReportId
}: {
  onNavigate: (s: ScreenType) => void;
  selectedReportId: string | null;
}) {
  const report = useStore(s => s.reports).find(r => r.id === selectedReportId);
  if (!report) return null;
  return <div className="space-y-6 animate-in slide-in-from-right-4 pb-20" data-id="element-2292">
      <div className="flex items-center gap-3" data-id="element-2293">
        <Button variant="ghost" size="icon" onClick={() => onNavigate('history')} data-id="element-2294">
          <ChevronLeft className="w-6 h-6" data-id="element-2295" />
        </Button>
        <h2 className="text-lg font-bold" data-id="element-2296">Detail Laporan</h2>
      </div>

      <div className="bg-black/40 border border-border/50 rounded-xl p-5 space-y-4" data-id="element-2297">
        <div className="flex justify-between items-start" data-id="element-2298">
          <div data-id="element-2299">
            <div className="text-xs font-mono text-muted-foreground mb-1" data-id="element-2300">
              {report.id}
            </div>
            <h3 className="text-lg font-bold" data-id="element-2301">{report.title}</h3>
          </div>
          <StatusBadge status={report.status} data-id="element-2302" />
        </div>

        <div className="grid grid-cols-2 gap-4 py-4 border-y border-border/50" data-id="element-2303">
          <div data-id="element-2304">
            <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2305">
              Kategori
            </div>
            <div className="text-sm font-medium" data-id="element-2306">{report.category}</div>
          </div>
          <div data-id="element-2307">
            <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2308">
              Urgensi
            </div>
            <UrgencyBadge urgency={report.urgency as any} className="text-xs" data-id="element-2309" />
          </div>
          <div data-id="element-2310">
            <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2311">
              Waktu
            </div>
            <div className="text-sm font-mono" data-id="element-2312">{report.time}</div>
          </div>
          <div data-id="element-2313">
            <div className="text-xs text-muted-foreground uppercase mb-1" data-id="element-2314">
              Lokasi
            </div>
            <div className="text-sm font-medium" data-id="element-2315">{report.region}</div>
          </div>
        </div>

        <div data-id="element-2316">
          <div className="text-xs text-muted-foreground uppercase mb-2" data-id="element-2317">
            Isi Laporan
          </div>
          <div className="text-sm leading-relaxed p-4 bg-black/30 rounded-lg border border-border/30" data-id="element-2318">
            {report.description || report.ringkasan || 'Tidak ada deskripsi.'}
          </div>
        </div>
      </div>

      {report.status === 'Ditolak' && report.rejectReason && <div className="bg-destructive/10 border border-destructive/30 rounded-xl p-4" data-id="element-2319">
          <div className="flex items-center gap-2 text-destructive font-bold mb-2" data-id="element-2320">
            <AlertTriangle className="w-4 h-4" data-id="element-2321" /> Alasan Penolakan
          </div>
          <p className="text-sm text-destructive/90" data-id="element-2322">{report.rejectReason}</p>
        </div>}

      {report.status === 'Diterima Nasional' && <div className="bg-[var(--status-active)]/10 border border-[var(--status-active)]/30 rounded-xl p-4" data-id="element-2323">
          <div className="flex items-center gap-2 text-[var(--status-active)] font-bold mb-2" data-id="element-2324">
            <Target className="w-4 h-4" data-id="element-2325" /> Dampak KPI
          </div>
          <p className="text-sm text-[var(--status-active)]/90" data-id="element-2326">
            Laporan ini telah diterima sebagai Produk Intelijen Resmi Nasional.
            (+15 Poin KPI)
          </p>
        </div>}

      <div className="bg-black/40 border border-border/50 rounded-xl p-5" data-id="element-2327">
        <h4 className="text-sm font-bold uppercase text-muted-foreground mb-4" data-id="element-2328">
          Timeline Status
        </h4>
        <div className="space-y-4" data-id="element-2329">
          {report.timeline?.map((t, i) => <div key={i} className="flex gap-4" data-id="element-2330">
              <div className="flex flex-col items-center" data-id="element-2331">
                <div className="w-3 h-3 rounded-full bg-primary mt-1 shadow-[0_0_10px_rgba(var(--primary),0.5)]" data-id="element-2332"></div>
                {i !== report.timeline!.length - 1 && <div className="w-px h-full bg-border/50 my-1" data-id="element-2333"></div>}
              </div>
              <div className="pb-4" data-id="element-2334">
                <div className="text-sm font-bold text-primary" data-id="element-2335">{t.stage}</div>
                <div className="text-xs font-mono text-muted-foreground mt-0.5" data-id="element-2336">
                  {t.time} - {t.actor}
                </div>
                <div className="text-sm text-foreground/80 mt-2" data-id="element-2337">{t.note}</div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}
function KPIScreen({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  const personalKpi = useStore(s => s.personalKpi);
  const kpiHistory = useStore(s => s.kpiHistory);
  return <div className="space-y-6 animate-in fade-in pb-20" data-id="element-2338">
      <h2 className="text-xl font-bold" data-id="element-2339">KPI Pribadi</h2>

      <div className="bg-primary/10 border border-primary/30 rounded-2xl p-6 text-center relative overflow-hidden" data-id="element-2340">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-2341"></div>
        <div className="relative z-10" data-id="element-2342">
          <div className="text-sm font-bold text-primary uppercase tracking-widest mb-2" data-id="element-2343">
            Skor Kinerja
          </div>
          <div className="text-6xl font-mono font-bold text-foreground mb-2" data-id="element-2344">
            {personalKpi.score}
          </div>
          <Badge className="bg-primary text-primary-foreground text-sm px-4 py-1" data-id="element-2345">
            GRADE A
          </Badge>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3" data-id="element-2346">
        <Card className="bg-black/40 border-border/50" data-id="element-2347">
          <CardContent className="p-4 text-center" data-id="element-2348">
            <div className="text-2xl font-mono text-foreground mb-1" data-id="element-2349">#4</div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2350">
              Ranking BINDA
            </div>
          </CardContent>
        </Card>
        <Card className="bg-black/40 border-border/50" data-id="element-2351">
          <CardContent className="p-4 text-center" data-id="element-2352">
            <div className="text-2xl font-mono text-foreground mb-1" data-id="element-2353">#142</div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2354">
              Ranking Nasional
            </div>
          </CardContent>
        </Card>
        <Card className="bg-black/40 border-border/50" data-id="element-2355">
          <CardContent className="p-4 text-center" data-id="element-2356">
            <div className="text-2xl font-mono text-[var(--status-active)] mb-1" data-id="element-2357">
              {personalKpi.verified}
            </div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2358">
              Diterima Nasional
            </div>
          </CardContent>
        </Card>
        <Card className="bg-black/40 border-border/50" data-id="element-2359">
          <CardContent className="p-4 text-center" data-id="element-2360">
            <div className="text-2xl font-mono text-destructive mb-1" data-id="element-2361">2</div>
            <div className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2362">
              Laporan Ditolak
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="bg-black/40 border border-border/50 rounded-xl p-4" data-id="element-2363">
        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4" data-id="element-2364">
          <AlertTriangle className="w-4 h-4 text-[var(--status-standby)]" data-id="element-2365" />
          Hanya laporan yang berstatus "Diterima Nasional" yang menambah poin
          KPI secara penuh.
        </div>

        <h4 className="text-sm font-bold uppercase text-muted-foreground mb-4" data-id="element-2366">
          Riwayat Dampak KPI
        </h4>
        <div className="space-y-3" data-id="element-2367">
          {kpiHistory.length > 0 ? kpiHistory.map((h, i) => <div key={i} className="border-b border-border/50 pb-3 last:border-0 last:pb-0" data-id="element-2368">
                <div className="flex justify-between items-start mb-1" data-id="element-2369">
                  <div className="text-sm font-bold" data-id="element-2370">{h.reason}</div>
                  <div className="text-sm font-mono font-bold text-[var(--status-active)]" data-id="element-2371">
                    +{h.delta}
                  </div>
                </div>
                <div className="flex justify-between items-center text-xs text-muted-foreground" data-id="element-2372">
                  <span className="font-mono" data-id="element-2373">{h.target}</span>
                  <span data-id="element-2374">{h.time}</span>
                </div>
              </div>) : <div className="text-center text-sm text-muted-foreground py-4" data-id="element-2375">
              Belum ada riwayat KPI.
            </div>}
        </div>
      </div>
    </div>;
}
function ProfileScreen({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  return <div className="space-y-6 animate-in fade-in pb-20 pt-4" data-id="element-2376">
      <div className="flex flex-col items-center text-center" data-id="element-2377">
        <div className="w-24 h-24 bg-black/40 border-2 border-primary/50 rounded-full flex items-center justify-center mb-4 relative" data-id="element-2378">
          <User className="w-12 h-12 text-muted-foreground" data-id="element-2379" />
          <div className="absolute bottom-0 right-0 w-6 h-6 bg-[var(--status-active)] rounded-full border-2 border-background flex items-center justify-center" data-id="element-2380">
            <CheckCircle className="w-4 h-4 text-background" data-id="element-2381" />
          </div>
        </div>
        <h2 className="text-2xl font-bold" data-id="element-2382">Budi Santoso</h2>
        <p className="text-sm font-mono text-primary mt-1" data-id="element-2383">ID: OP-772</p>
        <Badge variant="outline" className="mt-2" data-id="element-2384">
          Personel Lapangan
        </Badge>
      </div>

      <div className="bg-black/40 border border-border/50 rounded-xl overflow-hidden" data-id="element-2385">
        <div className="p-4 border-b border-border/50 flex justify-between items-center" data-id="element-2386">
          <span className="text-sm text-muted-foreground" data-id="element-2387">BINDA</span>
          <span className="text-sm font-bold" data-id="element-2388">DKI Jakarta</span>
        </div>
        <div className="p-4 border-b border-border/50 flex justify-between items-center" data-id="element-2389">
          <span className="text-sm text-muted-foreground" data-id="element-2390">Unit</span>
          <span className="text-sm font-bold" data-id="element-2391">Operasional Lapangan</span>
        </div>
        <div className="p-4 border-b border-border/50 flex justify-between items-center" data-id="element-2392">
          <span className="text-sm text-muted-foreground" data-id="element-2393">Wilayah Tugas</span>
          <span className="text-sm font-bold" data-id="element-2394">Sektor Pusat</span>
        </div>
        <div className="p-4 border-b border-border/50 flex justify-between items-center" data-id="element-2395">
          <span className="text-sm text-muted-foreground" data-id="element-2396">Status Akun</span>
          <span className="text-sm font-bold text-[var(--status-active)]" data-id="element-2397">
            Aktif
          </span>
        </div>
        <div className="p-4 border-b border-border/50 flex justify-between items-center" data-id="element-2398">
          <span className="text-sm text-muted-foreground" data-id="element-2399">
            Status Perangkat
          </span>
          <span className="text-sm font-bold text-[var(--status-active)] flex items-center gap-1" data-id="element-2400">
            <CheckCircle className="w-4 h-4" data-id="element-2401" /> Terenkripsi
          </span>
        </div>
        <div className="p-4 flex justify-between items-center" data-id="element-2402">
          <span className="text-sm text-muted-foreground" data-id="element-2403">Versi Aplikasi</span>
          <span className="text-sm font-mono" data-id="element-2404">v2.4.1 (Build 882)</span>
        </div>
      </div>

      <div className="space-y-3" data-id="element-2405">
        <Button variant="outline" className="w-full h-12 justify-start px-4" data-id="element-2406">
          <RefreshCw className="w-5 h-5 mr-3 text-muted-foreground" data-id="element-2407" />{' '}
          Sinkronisasi Data
        </Button>
        <Button variant="outline" className="w-full h-12 justify-start px-4" data-id="element-2408">
          <Smartphone className="w-5 h-5 mr-3 text-muted-foreground" data-id="element-2409" /> Reset
          Perangkat
        </Button>
        <Button variant="outline" className="w-full h-12 justify-start px-4 border-destructive text-destructive hover:bg-destructive/10" onClick={() => onNavigate('login')} data-id="element-2410">
          <LogOut className="w-5 h-5 mr-3" data-id="element-2411" /> Keluar
        </Button>
      </div>
    </div>;
}
function PanicScreen({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  const [holding, setHolding] = useState(false);
  const [progress, setProgress] = useState(0);
  const [sent, setSent] = useState(false);
  const createPanicAlert = useStore(s => s.createPanicAlert);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const handleTouchStart = () => {
    if (sent) return;
    setHolding(true);
    let p = 0;
    timerRef.current = setInterval(() => {
      p += 5;
      setProgress(p);
      if (p >= 100) {
        if (timerRef.current) clearInterval(timerRef.current);
        handleTrigger();
      }
    }, 150); // 3 seconds total (100 / 5 * 150 = 3000ms)
  };
  const handleTouchEnd = () => {
    if (sent) return;
    setHolding(false);
    setProgress(0);
    if (timerRef.current) clearInterval(timerRef.current);
  };
  const handleTrigger = () => {
    setSent(true);
    createPanicAlert('OP-772', 'DKI Jakarta (-6.2088, 106.8456)');
    toast.error('Sinyal Darurat Terkirim ke Command Center!');
  };
  if (sent) {
    return <div className="fixed inset-0 bg-destructive z-50 flex flex-col items-center justify-center animate-in fade-in p-6 text-center" data-id="element-2412">
        <div className="w-32 h-32 rounded-full bg-white/20 flex items-center justify-center mb-8 animate-pulse" data-id="element-2413">
          <AlertTriangle className="w-16 h-16 text-white" data-id="element-2414" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-2415">
          PANIC ALERT TERKIRIM
        </h2>
        <p className="text-white/80 mb-8" data-id="element-2416">
          Lokasi dan audio sedang ditransmisikan ke Pusat Komando. Bantuan
          sedang dikoordinasikan.
        </p>
        <div className="bg-black/20 rounded-xl p-4 w-full mb-8" data-id="element-2417">
          <div className="text-sm text-white/60 uppercase mb-1" data-id="element-2418">Status</div>
          <div className="text-lg font-bold text-white" data-id="element-2419">
            Menunggu Tindak Lanjut
          </div>
        </div>
        <Button variant="outline" className="w-full h-14 border-white text-white hover:bg-white hover:text-destructive" onClick={() => onNavigate('dashboard')} data-id="element-2420">
          Kembali ke Beranda
        </Button>
      </div>;
  }
  return <div className="fixed inset-0 bg-background z-50 flex flex-col items-center justify-center p-6 animate-in fade-in" data-id="element-2421">
      <Button variant="ghost" className="absolute top-safe-4 left-4" onClick={() => onNavigate('dashboard')} data-id="element-2422">
        <X className="w-6 h-6" data-id="element-2423" />
      </Button>

      <div className="text-center mb-12" data-id="element-2424">
        <h2 className="text-3xl font-bold text-destructive mb-2" data-id="element-2425">
          PANIC BUTTON
        </h2>
        <p className="text-muted-foreground" data-id="element-2426">
          Gunakan hanya dalam kondisi darurat yang mengancam jiwa atau operasi.
        </p>
      </div>

      <div className="relative w-64 h-64 flex items-center justify-center" data-id="element-2427">
        {/* Progress Ring */}
        <svg className="absolute inset-0 w-full h-full -rotate-90" data-id="element-2428">
          <circle cx="128" cy="128" r="120" className="stroke-muted fill-none" strokeWidth="8" data-id="element-2429" />
          <circle cx="128" cy="128" r="120" className="stroke-destructive fill-none transition-all duration-150" strokeWidth="8" strokeDasharray="754" strokeDashoffset={754 - 754 * progress / 100} data-id="element-2430" />
        </svg>

        <button onMouseDown={handleTouchStart} onMouseUp={handleTouchEnd} onMouseLeave={handleTouchEnd} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} className={`w-48 h-48 rounded-full bg-destructive flex items-center justify-center shadow-[0_0_50px_rgba(var(--destructive),0.5)] transition-transform ${holding ? 'scale-95' : 'scale-100'}`} data-id="element-2431">
          <AlertTriangle className="w-20 h-20 text-destructive-foreground" data-id="element-2432" />
        </button>
      </div>

      <div className="mt-12 text-center" data-id="element-2433">
        <div className="text-lg font-bold animate-pulse" data-id="element-2434">
          TEKAN DAN TAHAN 3 DETIK
        </div>
      </div>
    </div>;
}
function NotificationsScreen({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  return <div className="space-y-4 animate-in slide-in-from-right-4 pb-20" data-id="element-2435">
      <div className="flex items-center gap-3 mb-6" data-id="element-2436">
        <Button variant="ghost" size="icon" onClick={() => onNavigate('dashboard')} data-id="element-2437">
          <ChevronLeft className="w-6 h-6" data-id="element-2438" />
        </Button>
        <h2 className="text-lg font-bold" data-id="element-2439">Notifikasi</h2>
      </div>

      <div className="space-y-3" data-id="element-2440">
        <div className="bg-black/40 border border-primary/30 rounded-xl p-4 flex gap-4" data-id="element-2441">
          <div className="mt-1" data-id="element-2442">
            <Bell className="w-5 h-5 text-primary" data-id="element-2443" />
          </div>
          <div data-id="element-2444">
            <div className="flex justify-between items-start mb-1" data-id="element-2445">
              <h4 className="font-bold text-sm" data-id="element-2446">Laporan Diterima Nasional</h4>
              <span className="text-xs font-mono text-muted-foreground" data-id="element-2447">
                Baru saja
              </span>
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-2448">
              Laporan DC-LAP-2026-000184 telah diterima sebagai Produk Intelijen
              Resmi. (+15 KPI)
            </p>
          </div>
        </div>
        <div className="bg-black/40 border border-border/50 rounded-xl p-4 flex gap-4 opacity-70" data-id="element-2449">
          <div className="mt-1" data-id="element-2450">
            <AlertTriangle className="w-5 h-5 text-[var(--status-standby)]" data-id="element-2451" />
          </div>
          <div data-id="element-2452">
            <div className="flex justify-between items-start mb-1" data-id="element-2453">
              <h4 className="font-bold text-sm" data-id="element-2454">Peringatan Cuaca</h4>
              <span className="text-xs font-mono text-muted-foreground" data-id="element-2455">
                2 jam lalu
              </span>
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-2456">
              Hujan badai diprediksi di wilayah operasi Sektor Pusat.
            </p>
          </div>
        </div>
      </div>
    </div>;
}
function TasksScreen({
  onNavigate
}: {
  onNavigate: (s: ScreenType) => void;
}) {
  const {
    tasks,
    submitAnswer
  } = useUkstrStore();
  const activeTasks = tasks.filter(t => t.status === 'Diterbitkan');
  const [selectedTask, setSelectedTask] = useState<any>(null);
  const [ringkasan, setRingkasan] = useState('');
  const [uraian, setUraian] = useState('');
  const [lokasi, setLokasi] = useState('');
  const handleKirim = () => {
    if (!ringkasan || !uraian) return toast.error('Ringkasan dan Uraian wajib diisi.');
    submitAnswer({
      taskId: selectedTask.id,
      personelId: 'PL-001',
      personelName: 'Agen Alpha',
      wilayah: 'DKI Jakarta',
      ringkasan,
      uraian,
      kronologi: '',
      pihakTerkait: '',
      lokasi,
      lampiran: [],
      catatan: ''
    });
    toast.success('Jawaban berhasil dikirim.');
    setSelectedTask(null);
  };
  if (selectedTask) {
    return <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4 pb-20" data-id="element-2457">
        <div className="flex items-center gap-3 mb-6" data-id="element-2458">
          <button onClick={() => setSelectedTask(null)} className="p-2 -ml-2 text-muted-foreground hover:text-foreground" data-id="element-2459">
            <ChevronLeft className="w-6 h-6" data-id="element-2460" />
          </button>
          <h2 className="text-lg font-heading font-bold tracking-widest text-primary uppercase" data-id="element-2461">
            Jawab Tugas
          </h2>
        </div>
        <Card className="glass-panel border-border/50" data-id="element-2462">
          <CardContent className="p-4 space-y-4" data-id="element-2463">
            <div className="text-xs font-mono text-muted-foreground uppercase" data-id="element-2464">
              {selectedTask.nomor}
            </div>
            <div className="font-bold" data-id="element-2465">{selectedTask.judul}</div>
            <div className="space-y-1" data-id="element-2466">
              <label className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2467">
                Ringkasan Informasi
              </label>
              <textarea className="w-full bg-black/40 border border-border/50 rounded p-2 text-xs font-mono focus:border-primary/50 outline-none" value={ringkasan} onChange={e => setRingkasan(e.target.value)} data-id="element-2468" />
            </div>
            <div className="space-y-1" data-id="element-2469">
              <label className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2470">
                Uraian Lapangan
              </label>
              <textarea className="w-full bg-black/40 border border-border/50 rounded p-2 text-xs font-mono focus:border-primary/50 outline-none min-h-[100px]" value={uraian} onChange={e => setUraian(e.target.value)} data-id="element-2471" />
            </div>
            <div className="space-y-1" data-id="element-2472">
              <label className="text-[10px] font-mono uppercase text-muted-foreground" data-id="element-2473">
                Lokasi
              </label>
              <input type="text" className="w-full bg-black/40 border border-border/50 rounded p-2 text-xs font-mono focus:border-primary/50 outline-none" value={lokasi} onChange={e => setLokasi(e.target.value)} data-id="element-2474" />
            </div>
            <Button onClick={handleKirim} className="w-full bg-primary text-primary-foreground font-mono text-xs mt-4" data-id="element-2475">
              <Send className="w-4 h-4 mr-2" data-id="element-2476" /> Kirim Jawaban
            </Button>
          </CardContent>
        </Card>
      </div>;
  }
  return <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4 pb-20" data-id="element-2477">
      <div className="flex items-center justify-between mb-6" data-id="element-2478">
        <h2 className="text-xl font-heading font-bold tracking-widest text-primary uppercase" data-id="element-2479">
          Tugas UK/STR
        </h2>
      </div>
      <div className="space-y-4" data-id="element-2480">
        {activeTasks.map(task => <Card key={task.id} className="glass-panel border-border/50" data-id="element-2481">
            <CardContent className="p-4" data-id="element-2482">
              <div className="flex justify-between items-start mb-2" data-id="element-2483">
                <div className="text-[10px] font-mono text-muted-foreground uppercase" data-id="element-2484">
                  {task.nomor}
                </div>
                <Badge variant="outline" className="text-[9px] font-mono text-orange-500 border-orange-500/50" data-id="element-2485">
                  Deadline: {task.batasWaktu}
                </Badge>
              </div>
              <div className="font-bold text-sm mb-2" data-id="element-2486">{task.judul}</div>
              <div className="text-xs text-muted-foreground line-clamp-2 mb-4" data-id="element-2487">
                {task.uraian}
              </div>
              <Button onClick={() => setSelectedTask(task)} className="w-full bg-primary/20 text-primary hover:bg-primary hover:text-primary-foreground font-mono text-xs" data-id="element-2488">
                Jawab Tugas
              </Button>
            </CardContent>
          </Card>)}
        {activeTasks.length === 0 && <div className="text-center py-12 text-muted-foreground font-mono text-xs border border-border/50 rounded glass-panel" data-id="element-2489">
            Tidak ada tugas aktif.
          </div>}
      </div>
    </div>;
}